// extracted by mini-css-extract-plugin
export var appContainer = "layout-module--appContainer--00fe8";
export var appLayout = "layout-module--appLayout--a8bf3";